Greenmile.RouteDetail = Greenmile.RouteDetail || {};

Greenmile.RouteDetail.MarkerSignature = function (map, routeId) {
  const kind = 'SIGNATURE';
  this.removeSignaturesFromMap = () => {
    Greenmile.Map.Utility.removeLayerByKind(map, [kind]);
  };

  this.checkAndDrawSignatures = function (signatures) {
    const markers = [];
    const points = [];
    signatures.models.forEach((item) => {
      const stopSignature = item.get('stopSignature') || {};
      const { latitude, longitude } = stopSignature;
      const { id, plannedSequenceNum,
        actualSequenceNum, redeliveryStop, redeliveryType, totalRedelivery } = item.get('stop');
      if (latitude && longitude) {
        markers.push(
          Greenmile.RouteDetail.Util.renderNumberedIconMarker(
            {
              id,
              latitude,
              longitude,
              plannedSequenceNum,
              actualSequenceNum,
              redeliveryStop,
              kind,
              color: 'orange'
            }
          )
        );
        points.push([latitude, longitude]);
      }
    });
    markers.forEach((marker) => {
      map.addLayer(marker);
    });
    if (points.length > 1) {
      map.fitBounds(points);
    }
  };

  this.getSignaturesAndDrawOnMap = () => {
    const success = (collection) => {
      this.removeSignaturesFromMap();
      this.checkAndDrawSignatures(collection);
    };
    const customCriteria = ['stopSignature.*'];
    App.Objects.RouteDetails.getStopDataToLayers(routeId, success, customCriteria);
  };
};
